import React, { Component } from 'react';
import { TextOnly } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';
import './styles.css';

/**
 * The about us section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class QrAboutView extends Component {

	render () {
		const {
			content,
			heading,
			subheading,
		} = this.props.content.qrLandingPage.about;

		return (
			<TextOnly
				{...{
					content,
					heading,
					subheading,
				}}
				className='QrAboutView'
			/>
		);
	}

}

export default withLanguageContext(QrAboutView);



// WEBPACK FOOTER //
// ./src/components/views/QrAboutView/QrAboutView.js